module.exports = __webpack_public_path__ + "img/icon-package-activation-policy-light.85d23c3.svg";